<div class="account-section">
  <div class="my-section-box">
    @if (tableData) {
      <form [formGroup]="endurasureSummaryForm">
        <div class="my-section-box__headline">
        {{ 'common.airDiscBrake_value_calculator_drumvsadb' | cxTranslate }}</div>
        <div class="my-section-box endurasureSummary" id="endurasureSummary">
          <div class="my-section-box-inner">
            <div class="enduraSuretable-css">
              <table class="EnduraSureTable">
                <tbody>
                  <th colspan="5">
                    @if (isTractor) {
                      <span class="ShowTractor">{{
                        'common.airDiscBrake_value_calculator_tractorDrumvsAirDiscBrakeSummaryCosts'
                      | cxTranslate}} </span>
                    }
                    @if (!isTractor) {
                      <span class="ShowTractor">{{
                        'common.airDiscBrake_value_calculator_trailerDrumvsAirDiscBrakeSummaryCosts'
                      | cxTranslate}} </span>
                    }
                  </th>
                  <tr>
                    <th colspan="2">
                      {{ 'common.airDiscBrake_value_calculator_drum' | cxTranslate}}
                    </th>
                    <th rowspan="2">
                      {{ 'common.airDiscBrake_value_calculator_description' | cxTranslate}}
                    </th>
                    <th colspan="2">
                      {{ 'common.airDiscBrake_value_calculator_adb' | cxTranslate }}
                    </th>
                  </tr>
                  <tr>
                    <th>{{ 'common.value_calculator_unit_cost' | cxTranslate }}</th>
                    <th>{{ 'common.value_calculator_totalFleet_cost' | cxTranslate }}</th>
                    <th>{{ 'common.value_calculator_unit_cost' | cxTranslate }}</th>
                    <th>{{ 'common.value_calculator_totalFleet_cost' | cxTranslate }}</th>
                  </tr>
                  <tr>
                    <td class="standard-Unit-Tractor">{{tableData[0]?.drumUnit.toFixed(2)}}</td>
                    <td class="standard-Fleet-Tractor">
                      {{tableData[0]?.drumFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                    <td>{{ 'common.airDiscBrake_value_calculator_initialpurchase_cost' | cxTranslate
                    }}</td>
                    <td class="sealed-Unit-Tractor">{{tableData[0]?.ADBUnit.toFixed(2)}}</td>
                    <td class="sealed-Fleet-Tractor">
                      {{tableData[0]?.ADBFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                  </tr>
                  <tr>
                    <td class="standard-Unit-Trailer">{{tableData[1]?.drumUnit.toFixed(2)}}</td>
                    <td class="standard-Total-Trailer">
                      {{tableData[1]?.drumFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                    <td>{{ 'common.airDiscBrake_value_calculator_residualValueAtTradeIn' |
                    cxTranslate }}</td>
                    <td class="sealed-Unit-Trailer">{{tableData[1]?.ADBUnit.toFixed(2)}}</td>
                    <td class="sealed-Fleet-Trailer">
                      {{tableData[1]?.ADBFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                  </tr>
                  <tr>
                    <td class="standard-Unit-life-Tractor">{{tableData[2]?.drumUnit.toFixed(2)}}
                    </td>
                    <td class="standard-Total-life-Tractor">
                      {{tableData[2]?.drumFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                    <td>{{ 'common.airDiscBrake_value_calculator_estimatedImpactOfSafety' |
                    cxTranslate }}</td>
                    <td class="sealed-Unit-life-Tractor">{{tableData[2]?.ADBUnit.toFixed(2)}}</td>
                    <td class="sealed-Fleet-life-Tractor">
                      {{tableData[2]?.ADBFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                  </tr>
                  <tr>
                    <td class="standard-Unit-life-Trailer">{{tableData[3]?.drumUnit.toFixed(2)}}
                    </td>
                    <td class="standard-Fleet-life-Trailer">
                      {{tableData[3]?.drumFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                    <td>{{
                      'common.airDiscBrake_value_calculator_estimatedReplacementMaintenanceCost' |
                    cxTranslate }}</td>
                    <td class="sealed-Unit-life-Trailer">{{tableData[3]?.ADBUnit.toFixed(2)}}</td>
                    <td class="sealed-Fleet-life-Trailer">
                      {{tableData[3]?.ADBFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                  </tr>
                  <tr>
                    <td class="standard-Unit-csaTractor">{{tableData[4]?.drumUnit.toFixed(2)}}</td>
                    <td class="standard-Fleet-csaTractor">
                      {{tableData[4]?.drumFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                    <td>{{ 'common.airDiscBrake_value_calculator_continuiousMaintananceCost' |
                    cxTranslate }}</td>
                    <td class="sealed-Unit-csaTractor">{{tableData[4]?.ADBUnit.toFixed(2)}}</td>
                    <td class="sealed-Fleet-csaTractor">
                      {{tableData[4]?.ADBFleet.toLocaleString('en-US', { style:
                    'decimal',maximumFractionDigits: 0 })}}</td>
                  </tr>
                  <tr>
                    <td class="standard-Unit-csaTrailer">{{tableData[5]?.drumUnit.toFixed(2)}}</td>
                    <td class="standard-Fleet-csaTrailer">
                      {{tableData[5]?.drumFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                    <td>{{ 'common.airDiscBrake_value_calculator_csaRelatedCosts' | cxTranslate }}
                    </td>
                    <td class="sealed-Unit-csaTrailer">{{tableData[5]?.ADBUnit.toFixed(2)}}</td>
                    <td class="sealed-Fleet-csaTrailer">
                      {{tableData[5]?.ADBFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                  </tr>
                  <tr>
                    <td class="standard-Unit-csaTrailer">{{tableData[6]?.drumUnit.toFixed(2)}}</td>
                    <td class="standard-Fleet-csaTrailer">
                      {{tableData[6]?.drumFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                    <td>{{ 'common.airDiscBrake_value_calculator_rustJackingCosts' | cxTranslate }}
                    </td>
                    <td class="sealed-Unit-csaTrailer">{{tableData[6]?.ADBUnit.toFixed(2)}}</td>
                    <td class="sealed-Fleet-csaTrailer">
                      {{tableData[6]?.ADBFleet.toLocaleString('en-US', { style: 'decimal',
                    maximumFractionDigits: 0 })}}</td>
                  </tr>
                  <tr>
                    <td class="standard-Unit-Total ui-weight">{{tableData[7]?.drumUnit.toFixed(2)}}
                    </td>
                    <td class="standard-Fleet-Total ui-weight">
                      {{tableData[7]?.drumFleet.toLocaleString('en-US', { style:
                    'decimal',maximumFractionDigits: 0 })}}</td>
                    <td class="ui-weight">{{ 'common.airDiscBrake_value_calculator_total_text' |
                      cxTranslate }}
                    </td>
                    <td class="sealed-Unit-Total ui-weight">{{tableData[7]?.ADBUnit.toFixed(2)}}
                    </td>
                    <td class="sealed-Fleet-Total ui-weight">
                      {{tableData[7]?.ADBFleet.toLocaleString('en-US', { style:
                    'decimal',maximumFractionDigits: 0 })}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br>
              <div class="enduraSuretable2-css">
                <table class="ROITable">
                  <tbody>
                    <tr>
                      <th colspan="2">{{ 'common.value_calculator_return_investment' | cxTranslate }}
                      </th>
                    </tr>
                    <tr class="ui-weight">
                      <td class="roi_left">{{
                        'common.airDiscBrake_value_calculator_roiOverLifeCycleUSD_UNIT' |
                      cxTranslate}}</td>
                      <td class="TCO-Standard">{{tableData[8]?.roiOverLifeCycle_USD_UNIT.toFixed(2)}}
                      </td>
                    </tr>
                    <tr class="ui-weight">
                      <td class="roi_left">{{
                        'common.airDiscBrake_value_calculator_roiOVerLifeCycleUSD' | cxTranslate}}
                      </td>
                      <td class="TCO-Sealed">
                        {{tableData[8]?.roiOverLifeCycle_USD.toLocaleString('en-US', { style:
                      'decimal',maximumFractionDigits: 0 })}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br>
                <br>
                  <div class="paragraph-Summary">
                    <b>{{ 'common.airdiscBrake_value_calculator_negative_estimated_roi' | cxTranslate}}</b>
                    <p>{{ 'common.airdiscBrake_drum_summary_paragraph1' | cxTranslate}}</p>
                    <p>{{ 'common.airdiscBrake_drum_summary_paragraph2' | cxTranslate}}</p>
                    <p>{{ 'common.airdiscBrake_drum_summary_paragraph3' | cxTranslate}}</p>
                    <p>{{ 'common.airdiscBrake_drum_summary_paragraph4' | cxTranslate}}</p>
                    <p>{{ 'common.airdiscBrake_drum_summary_paragraph5' | cxTranslate}}</p>
                    <p>{{ 'common.airdiscBrake_drum_summary_paragraph6' | cxTranslate}}</p>
                  </div>
                  <div class="airdisk-button-block endasure-button-block">
                    <button type="button" class="btn btn-primary endaSureBack  yellow-btn"
                      (click)="endaSureBack()"><img src="/icons/link-right-white.svg" alt="Back"
                      class="right-arrow">
                    {{ 'common.value_calculator_back_button' | cxTranslate }}</button>
                    <button type="button" class="btn btn-primary endaSureRest  yellow-btn"
                      (click)="resetForms()">{{ 'common.value_calculator_reset_text' | cxTranslate }}
                      <img src="/icons/link-right-white.svg" class="right-arrow" alt="Reset Forms"></button>
                      <mat-dialog-actions>
                        <button type="button" class="btn btn-primary EmailResults yellow-btn"
                          (click)="emailPopup()">{{ 'common.value_calculator_email_results' | cxTranslate }}
                          <img src="/icons/link-right-white.svg" class="right-arrow"
                          alt="Email Results"></button>
                        </mat-dialog-actions>
                      </div>
                    </div>
                  </div>
                </form>
              }
            </div>
          </div>